<template>
  <div class="right_col" role="main">
    <div class="">
      <div class="page-title">
        <div class="title_left">
          <h3>{{ $t('subMenu.groupConfig') }}</h3>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="col-md-12 col-sm-12 col-xs-12">
      <div class="x_panel item_list">
        <div class="x_content">
          <alert
            :title="alertTitle"
            :success-message="$t('common.isSuccess')"
            :error-message="$t('common.isFailure')"
            :alerts="alerts"
            :errors="errors"
            :display="alertDisplay"
            @closeAlert="closeAlert"
          />

          <div class="text-right">
            <router-link
              :to="{ name: 'groupCsvUpload' }"
              class="btn btn-primary"
              >{{ $t('common.csvUpload') }}</router-link
            >
          </div>
          <div id="datatable_wrapper" class="dataTables_wrapper form-inline">
            <div class="row" style="text-align: center">
              <div
                class="btn-group"
                data-toggle="buttons"
                style="width: 300px; margin: 0 auto"
              >
                <label :class="shopClass" class="btn">
                  <input
                    id="option1"
                    @click="active('item')"
                    type="radio"
                    name="options"
                  />
                  {{
                    $t('operationalManagementPage.shop')
                  }}&nbsp;&nbsp;<font-awesome-icon
                    icon="angle-double-right"
                  />&nbsp;&nbsp;{{ $t('operationalManagementPage.group') }}
                </label>
                <label id="" :class="groupClass" class="btn">
                  <input
                    id="option2"
                    @click="active('tag')"
                    type="radio"
                    name="options"
                  />
                  {{
                    $t('operationalManagementPage.group')
                  }}&nbsp;&nbsp;<font-awesome-icon
                    icon="angle-double-right"
                  />&nbsp;&nbsp;{{ $t('operationalManagementPage.shop') }}
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 col-md-offset-6">
                <div id="datatable_filter" class="dataTables_filter">
                  <label
                    >{{ $t('common.search') }}:
                    <input
                      v-model="searchString"
                      type="search"
                      class="form-control input-sm"
                      placeholder=""
                      aria-controls="datatable"
                    />
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <tag-table
                  :column-titles="columnTitles"
                  :items="items"
                  :suggests="suggests"
                  :placeholder="placeholder"
                  :search-string="searchString"
                  @deleteTag="deleteTag"
                  @inputSuggest="inputSuggest"
                  @postTag="postTag"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Alert from '@/components/common/alert/Alert'
import TagTable from '@/components/tag/TagTable'
import ShopRequest from '@/http/ShopRequest'
import { mapGetters } from 'vuex'
import alert from '@/mixin/alert'
export default {
  components: {
    Alert,
    TagTable,
  },
  mixins: [alert],
  data() {
    return {
      columnTitles: [],
      itemToTagsTitles: [
        this.$t('common.shopId'),
        this.$t('common.shopName'),
        this.$t('operationalManagementPage.group'),
      ],
      tagToItemsTitles: [
        this.$t('eventInformationPage.groupId'),
        this.$t('eventInformationPage.groupName'),
        this.$t('operationalManagementPage.shop'),
      ],
      items: [],
      suggests: [],
      placeholder: '',
      searchString: '',
      shopTableActive: false,
      allShopToGroups: [], // 検索用の店舗→グループリスト
      allGroupToShops: [], // 検索所用のグループ→店舗リスト
      activeButtonClass: ['btn-info', 'active'], // アクティブ時のクラス名
      deActiveButtonClass: ['btn-default'], // 非アクティブ時のクラス名
      shopClass: [], // 現在の店舗toグループのクラス名
      groupClass: [], // 現在のグループto店舗のクラス名
    }
  },
  computed: {
    ...mapGetters({
      fetchedGroupToShops: 'shop/getGroupToShops',
      fetchedShopToGroups: 'shop/getShopToGroups',
      language: 'settings/getLanguage',
    }),
  },
  watch: {
    fetchedShopToGroups: function(newFetchedData) {
      this.allShopToGroups = newFetchedData.map((shop) => {
        const groups = shop.groups.map((group) => {
          return Object.values(group)
        })
        return [shop.shopId, shop.name, groups]
      })
      if (this.shopTableActive) {
        this.items = this.allShopToGroups
      } else {
        this.suggests = this.allShopToGroups
      }
    },
    fetchedGroupToShops: function(newFetchedData) {
      this.allGroupToShops = newFetchedData.map((group) => {
        const shops = group.shops.map((shop) => {
          return Object.values(shop)
        })
        return [group.groupId, group.name, shops]
      })

      if (this.shopTableActive) {
        this.suggests = this.allGroupToShops
      } else {
        this.items = this.allGroupToShops
      }
    },
    language() {
      this.$store.dispatch('shop/getGroups')
    },
  },
  mounted() {
    this.$store.dispatch('shop/getGroups')
    this.shopToGroupsButtonActive()
  },
  methods: {
    // テーブルの切替
    active: function(event) {
      if (event === 'tag') {
        this.groupToShopsButtonActive()
      } else {
        this.shopToGroupsButtonActive()
      }
    },
    // 店舗toグループボタンのアクティブ化
    shopToGroupsButtonActive: function() {
      this.shopTableActive = true
      this.shopClass = this.activeButtonClass
      this.groupClass = this.deActiveButtonClass
      this.columnTitles = this.itemToTagsTitles
      this.items = this.allShopToGroups
      this.suggests = this.allGroupToShops
      this.placeholder = this.$t('operationalManagementPage.addGroup')
    },
    // グループto店舗ボタンのアクティブ化
    groupToShopsButtonActive: function() {
      this.shopTableActive = false
      this.shopClass = this.deActiveButtonClass
      this.groupClass = this.activeButtonClass
      this.columnTitles = this.tagToItemsTitles
      this.items = this.allGroupToShops
      this.suggests = this.allShopToGroups
      this.placeholder = this.$t('orderPage.addShop')
    },
    // 紐づけ削除
    deleteTag: function(itemId, tagId) {
      let shopId
      let groupId
      if (this.shopTableActive) {
        shopId = itemId
        groupId = tagId
      } else {
        shopId = tagId
        groupId = itemId
      }

      const request = new ShopRequest()
      request
        .deleteGroup(groupId, shopId)
        .then(() => {
          this.openSuccessAlert()
        })
        .catch((err) => {
          this.openErrorAlert(err.response.data)
        })
        .finally(() => {
          this.alertTitle = this.$t('operationalManagementPage.deleteShopGroup')
          this.$store.dispatch('shop/getGroups')
        })
    },
    // タグ送信
    postTag: function(id, tagName) {
      if (this.shopTableActive) {
        const params = {
          shopId: id,
          groupName: tagName,
        }
        this.postRequest(params)
      }
    },
    // サジェストからの入力
    inputSuggest: function(itemId, tagId) {
      let shopId
      let groupId
      if (this.shopTableActive) {
        shopId = itemId
        groupId = tagId
      } else {
        shopId = tagId
        groupId = itemId
      }
      const params = {
        shopId: shopId,
        groupId: groupId,
      }
      this.postRequest(params)
    },
    // タグ追加リクエスト送信
    postRequest: function(params) {
      const request = new ShopRequest()
      request
        .addGroup(params)
        .then(() => {
          this.openSuccessAlert()
        })
        .catch((err) => {
          this.openErrorAlert(err.response.data)
        })
        .finally(() => {
          this.alertTitle = this.$t('operationalManagementPage.addShopGroup')
          this.$store.dispatch('shop/getGroups')
        })
    },
  },
}
</script>
